import { useEffect, useState } from "react";

import { FormGroup, FormInput, FormInputGroup, FormTitle, InputLabel, ModalBtn, PlusIcon, PriceFormContainer, PricingForm, SubTitle, TableAction, TableActions, Title } from "Pricing/Styles";
import SelectField from "Business/AddBusiness/SelectField";
import SharedCheckList from "shared/clientcomponents/SharedCheckList";
import toast from "shared/utils/toast";
import { getCurrentUser } from "shared/utils/authToken";
import { pricingOBJ } from "Pricing/pricingClass";
import { Icon, OTPInput, Spinner } from "shared/components";
import { OtpContainer } from "Pricing/Single/Styles";
import Modal from "shared/quickComponents/modal";
import { AuxOtpText, OtpBtn, OtpBtnContainer } from "Auth/pages/ReceiveOtp/Styles";
import { color } from "shared/utils/styles";
import { Legend } from "chart.js";

let objBound={
    flat: 0,
    percentage: 0,
    cap: 0, 
    lower_bound: 0,
    upper_bound: 0,
    del: false
};
const AgencyBanking=()=>{
    const [bounds, setBounds] = useState<any>([{...objBound}]);
    const [service, setService] = useState<any>({});
    const [pricingName, setpricingName] = useState("");
    const [percentageValue, setpercentageValue] = useState("");
    const [fixedValue, setfixedValue] = useState("");
    const [benchmark, setBenchmark] = useState("0");
    const [cap, setCap] = useState("0");
    const [pageAction, setpageAction] = useState("CREATE");
    const [tempId, settempID] = useState("");
    const [showActivityIndicator, setshowActivityIndicator] = useState(false);
    const [planType, setplanType] = useState("");
    const [Otp, setOtp] = useState("");
    const [isOtpModalOpen, setisOtpModalOpen] = useState(false);
    const [isOTPError, setisOTPError] = useState(false);
    const [action, setaction] = useState("");
    const [selectedPlanID, setSelectedPlanID] = useState("");

    


    const options= [
        { label: "Select channel", value: "" },
        { label: "Withdrawer", value: "Withdrawer" },
        { label: "Transfer", value: "Transfer" },
        { label: "Airtime", value: "Airtime" },
        { label: "Data", value: "Data" },
        { label: "Electricity", value: "Electricity" },
        { label: "Cable", value: "Cable" },
        { label: "Utility", value: "Utility" },
    ]

    let btnText = pageAction === "CREATE" ? "Create" : "Edit";

    const currentUser = getCurrentUser(); //Get current login user

    const handleOTP = async (otp: string) => {
        if (otp.length === 6) {
            const otpResponse = await pricingOBJ.confirmOTP({
                otp,
                action,
                tempId,
            });
            if (otpResponse?.status) {
                setisOtpModalOpen(false)
            } 
        }
    };

    const onKeyChange=(key: string, e: string, id: number)=>{
        const newState = [...bounds];
        newState[id] = {
            ...newState[id],
            [key]: e
        };
        setBounds(newState)
    }

    //===== This handles submit button on modal ==========
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setshowActivityIndicator(true);
        try{
            const payload = {
                name: service.toString().toLocaleUpperCase(),
                value: bounds,
                app: "AGENCY_BANKING",
                channels: service.toString().toUpperCase()
            };
            
            //switch is based on page action state
            switch (pageAction) {
                case "EDIT":
                    const adminEmail = currentUser.email;
                    const pricingId = selectedPlanID;
                    const pricingPayload = {
                        name: pricingName,
                        value: {
                        percentage: percentageValue ? percentageValue : 0,
                        flat: fixedValue ? fixedValue : 0,
                        },
                    };
                    // // console.log("Edited payload ==>", payload, pageAction);
                    const feedback = await pricingOBJ.sendOTP({
                        adminEmail,
                        pricingId,
                        pricingPayload,
                    });
                    console.log("Feedback: ", feedback);
                    if (feedback?.status) {
                        //toast.success("OTP sent successfully!.");
                        // console.log("feedback data ====>", pricingPayload);
                        settempID(feedback.payload?.tempId);
                        setaction("UPDATE_PRICING_PLAN");
                        setisOtpModalOpen(true);
                        // getplans();
                    }
                break;

                default:
                
                    const response = await pricingOBJ.addPricing(payload);
                    //console.log("Response: ", response);
                    if (response.status) {
                        toast.success(response?.message);
                        setBounds([{...objBound}]);
                    } else {
                        toast.error(response.message);
                    }
                break;
            }
        }catch(error: any){
            console.log(error)
        }finally{
            setshowActivityIndicator(false);
        }
    };
    //==========================================================
    const removeBound=(index: number)=>{
        const oldState = bounds.filter((item: any, i: number)=>i != index);
        setBounds(oldState)
    }
    const createBound=()=>{
        objBound.del=true;
        const oldState = [...bounds, objBound];
        setBounds(oldState)
    }
    
    return(
        <>
            <FormTitle>
                {pageAction === "EDIT" ? "Edit pricing" : "Add Pricing"}
            </FormTitle>
            <PricingForm onSubmit={handleSubmit}>
                <FormInputGroup>
                    <InputLabel>Pricing Name</InputLabel>
                    <SelectField
                        value={service?.values}
                        setValue={(value: any) => setService(value)}
                        label="Select pricing name"
                        data={options}
                        />
                </FormInputGroup>
                <legend style={{marginBottom: "5px"}}>Bounds</legend>
                {
                    bounds instanceof Array && bounds.map((item: any, i: number)=>{
                        return(
                            <div key={i} style={{borderWidth:"1px", borderStyle:"solid", borderColor:"#ccc", borderRadius: "5px", padding: "10px", marginBottom: "10px"}}>
                                <FormGroup>
                                    <FormInputGroup>
                                        <InputLabel>Percentage (%)</InputLabel>
                                        <FormInput
                                        type="text"
                                        placeholder=""
                                        value={item.percentage}
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                            onKeyChange("percentage", event.target.value, i);
                                        }}
                                        />
                                    </FormInputGroup>

                                    <PlusIcon>+</PlusIcon>
                                    <FormInputGroup>
                                        <InputLabel>Fixed</InputLabel>
                                        <FormInput
                                        type="text"
                                        placeholder=""
                                        value={item.flat}
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                            onKeyChange("flat", event.target.value, i);
                                        }}
                                        />
                                    </FormInputGroup>
                                </FormGroup>
                                <FormGroup>
                                    <FormInputGroup>
                                        <InputLabel>Lower Bound</InputLabel>
                                        <FormInput
                                        type="text"
                                        placeholder=""
                                        value={item.lower_bound}
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                            onKeyChange("lower_bound", event.target.value, i);
                                        }}
                                        />
                                    </FormInputGroup>
                                    <FormInputGroup>
                                        <InputLabel>Upper Bound</InputLabel>
                                        <FormInput
                                        type="text"
                                        placeholder=""
                                        value={item.upper_bound}
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                            onKeyChange("upper_bound", event.target.value, i);
                                        }}
                                        />
                                    </FormInputGroup>
                                </FormGroup>
                                <FormGroup>
                                    <FormInputGroup>
                                        <InputLabel>Cap</InputLabel>
                                        <FormInput
                                        type="text"
                                        placeholder=""
                                        value={item.cap}
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                            onKeyChange("cap", event.target.value, i);
                                        }}
                                        />
                                    </FormInputGroup>

                                    {item.del && <Icon type={"trash"} size={50} style={{marginTop:"25px"}} onClick={()=>removeBound(i)} />}
                                </FormGroup>
                                
                            </div>
                        )
                    })
                }
                
                <ModalBtn 
                    type="button" 
                    variant={color.fountainLight}
                    onClick={()=>createBound()}
                >
                    <Icon type={"plus"} size={20} /> Add bounds
                </ModalBtn>
                
                <ModalBtn type="submit">
                    {showActivityIndicator ? <Spinner color="#fff" /> : btnText}
                </ModalBtn>
            </PricingForm>

            <Modal
                isOpen={isOtpModalOpen}
                closeButton={true}
                onClose={()=>{setisOtpModalOpen(false)}}
                width="40%"
            >
                <div style={{ paddingBottom: "2rem" }}>
                <Title>Check your email for OTP</Title>
                <SubTitle>
                    We have sent a 6 - digit code to your email address. <br /> The code
                    expires shortly, please enter it soon.
                </SubTitle>
                <OtpContainer>
                    {" "}
                    <OTPInput
                    autoFocus
                    isNumberInput
                    length={6}
                    hasError={isOTPError}
                    errorStyle={{
                        borderColor: "red",
                    }}
                    inputStyle={{
                        border: "1px solid #828282",
                        width: "60px",
                        height: "60px",
                        fontSize: "30px",
                        color: "#000",
                        fontWeight: "400",
                        caretColor: "#000",
                        textAlign: "center",
                        borderRight: "0px",
                    }}
                    focusStyle={
                        {
                        //border: "1px solid #CFD3DB",
                        }
                    }
                    firstIndexStyle={{
                        borderTopLeftRadius: "8px",
                        borderBottomLeftRadius: "8px",
                        borderRight: "0px",
                    }}
                    lastIndexStyle={{
                        borderTopRightRadius: "8px",
                        borderBottomRightRadius: "8px",
                        borderRight: "1px solid #828282",
                        borderLeft: "1px solid #828282",
                    }}
                    className="otpContainer"
                    inputClassName="otpInput"
                    separator={
                        <span
                        style={{
                            marginLeft: "10px",
                            marginRight: "10px",
                            marginTop: "10%",
                            fontSize: "50px",
                            color: "black",
                            fontWeight: "bold",
                        }}
                        >
                        -
                        </span>
                    }
                    onChangeOTP={handleOTP}
                    />
                </OtpContainer>
                <OtpBtnContainer>
                    <OtpBtn onClick={() => {}}>
                        You didn't get an OTP ?<AuxOtpText> Resend</AuxOtpText>
                    </OtpBtn>
                </OtpBtnContainer>
                </div>
            </Modal>
        </>
        
    )
}


export default AgencyBanking;